export default {
  dbList: [],
  dbSchema: [],
  newDb: '',
  errors: {
    dbListError: null,
    newDbError: null,
    getSchemaError: null,
    deleteDbError: null,
    editDbNameError: null
  },
  innError: {
    personal: '',
    organisation: ''
  },
  innInfo: {
    personal: '',
    organisation: ''
  },
  loading: {
    saveSchemaBtn: false,
    newDdBtn: false,
    editSchemaBtn: false,
    deleteDbLoading: false,
    editDbNameLoading: false,
    dbListLoading: false
  },
  editDbNameResponse: ''
}



// WEBPACK FOOTER //
// ./src/store/dbConstructor/state.js